import { combineReducers } from 'redux';

import {
    REQUEST_PARTNERS,
    RECEIVE_PARTNERS,
    FAILURE_PARTNERS,
    REQUEST_PARTNER_DETAILS,
    RECEIVE_PARTNER_DETAILS,
    FAILURE_PARTNER_DETAILS,
    REQUEST_OFFLINE_PARTNER,
    RECEIVE_OFFLINE_PARTNER,
    FAILURE_OFFLINE_PARTNER
} from './constants';

/*
 * State shape
 {
    partners: {
        [idPartner]: {object partner}
    },
    fetching: false,
    error: ''
 }
 */

const partners = (state = {}, action) => {
    switch (action.type) {
        case RECEIVE_PARTNERS:
            return action.response.payload;
        case REQUEST_PARTNER_DETAILS:
            return {
                ...state,
                [action.id]: {
                    ...state[action.id],
                    fetching: true
                }
            };
        case RECEIVE_PARTNER_DETAILS:
            return {
                ...state,
                [action.response.payload.id]: {
                    ...state[action.response.payload.id],
                    fetching: false,
                    ...action.response.payload
                }
            };
        case FAILURE_PARTNER_DETAILS:
            return {
                ...state,
                [action.response.payload.id]: {
                    ...state[action.response.payload.id],
                    fetching: false,
                    error: action.response.message
                }
            };
        default:
            return state;
    }
};

const offlinePartners = (state = {}, action) => {
    switch (action.type) {
        case RECEIVE_OFFLINE_PARTNER:
            return {
                ...state,
                [action.response.payload.moId]: {
                    ...action.response.payload
                }
            };
        default:
            return state;
    }
};

const fetching = (state = false, action) => {
    switch (action.type) {
        case REQUEST_PARTNERS:
            return true;
        case FAILURE_PARTNERS:
        case RECEIVE_PARTNERS:
            return false;
        default:
            return state;
    }
};

const offlineFetching = (state = false, action) => {
    switch (action.type) {
        case REQUEST_OFFLINE_PARTNER:
            return true;
        case FAILURE_OFFLINE_PARTNER:
        case RECEIVE_OFFLINE_PARTNER:
            return false;
        default:
            return state;
    }
};

const error = (state = '', action) => {
    switch (action.type) {
        case FAILURE_PARTNERS:
            return action.response.message;
        case REQUEST_PARTNERS:
        case RECEIVE_PARTNERS:
            return '';
        default:
            return state;
    }
};

const offlineError = (state = '', action) => {
    switch (action.type) {
        case FAILURE_OFFLINE_PARTNER:
            return action.response.message;
        case REQUEST_OFFLINE_PARTNER:
        case RECEIVE_OFFLINE_PARTNER:
            return '';
        default:
            return state;
    }
};

export default combineReducers({
    partners,
    offlinePartners,
    fetching,
    offlineFetching,
    error,
    offlineError
});



// WEBPACK FOOTER //
// ./src/services/partner/reducer.js